define('views/home/home',[
	'views/_base/baseview',
	'text!views/home/home.html',
	'views/savings/savings',
	'views/shop/shop',
	'views/home/notification',
	'views/shared/modal/modal_modern',
], function (BaseView, Template, Savings, Shop, Notification_Modal, Modal) {
	'use strict';

	return BaseView.extend({
		id: 'home-container',
		tagName: 'div',
		isRender: true,
		template: _.template(Template),
		events: {
			'click .termination-see-more': 'showSunsettingModal',
		},
		initialize: function (options) {
			options = options || {};

			this.elementName = options.elementName;
			this.options = options.options ? options.options : {};

			this.savings_preview = null;
			this.shop_preview = null;

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var shop_preview_options = {
					elementName: '#shop-home-preview-container',
				},
				savings_preview_options = {
					elementName: '#savings-home-preview-container',
				},
				wellness = pf.getFeature(enums.features.wellness);

			this.$el.html(this.template());

			if (wellness) {
				//
			} else {
				// Show the Shop full screen if routed from a deep link
				if (this.options.shop) {
					if (this.options.focused) {
						shop_preview_options.focused = true;
						shop_preview_options.className = 'focused';
					}

					if (this.options.type) {
						shop_preview_options.type = this.options.type;
					}

					if (this.options.merchant_guid) {
						shop_preview_options.merchant_guid = this.options.merchant_guid;
					}

					startMapSizingInterval();
				}

				this.savings_preview = new Savings(savings_preview_options);

				this.shop_preview = new Shop(shop_preview_options);
			}

			pf.home = this;

			if (isSunsetting()) {
				this.showSunsettingModal();
			}

			return this;
		},

		loadData: function () {},

		showSunsettingModal: function (e) {
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}

			if (window.location.href.indexOf('shop') !== -1) {
				return;
			}

			var termination_modal_view = new Notification_Modal(),
				modal = new Modal({
					show: true,
					content: termination_modal_view.$el.html(),
					calling_view: termination_modal_view,
				});

			// this is a hack so the modal window doesn't get pulled too far to the right

			$('#shop-home-preview-container').css('overflow-x', 'scroll');
		},

		resetPreviewSliders: function () {
			this.shop_preview.resetPreview();
			this.savings_preview.resetPreview();
		},

		close: function () {
			if (MapSizingInterval) {
				clearInterval(MapSizingInterval);
			}
		},
	});
});

